import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import DelayImage from "../../images/warning_delay.svg";
class DelayMinutes extends Component {
  constructor(props) {
    super(props);
    this.state = { delay: 0 };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.getMinutes(), 3000);
  }
  convertMinsToHrsMins(mins) {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    return h !== "00" ? h + " hr(s) : " + m : m;
  }

  getMinutes() {
    const currentDate = new Date();
    const pickedByDate = new Date(this.props.time);
    let milliseconds = currentDate - pickedByDate;
    let delay = Math.floor(milliseconds / 60000);
    if (delay > 0) {
      this.setState({ delay });
    }
  }
  // getMinutes() {
  //   const currentDate = new Date();
  //   let pickedByDate = new Date(this.props.time);
  //   pickedByDate.setFullYear(currentDate.getFullYear());
  //   let milliseconds = currentDate - pickedByDate;
  //   console.log("hours01", currentDate, pickedByDate, milliseconds);
  //   let delay = Math.floor(milliseconds / 60000);
  //   if (delay > 0) {
  //     this.setState({ delay });
  //   }
  // }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  addClass() {
    document
      .getElementById(`picked_${this.props.job_id}`)
      .classList.add("text-danger");
    return;
  }
  render() {
    return (
      <Row>
        {this.state.delay === 0 ? (
          <span></span>
        ) : (
          <Col xs="12" className="text-center delay-timer text-white py-1">
            {this.addClass()}
            <img className="pr-2" src={DelayImage} alt="delay_image" />
            {this.convertMinsToHrsMins(this.state.delay)} min delayed
          </Col>
        )}
      </Row>
    );
  }
}
export default DelayMinutes;



// WEBPACK FOOTER //
// ./src/components/Assigned/DelayMinutes.js